import { BaseCrudService } from "@/services/base";
import { Team, Zone } from "@/swagger/models";
import { AxiosRequestConfig } from "axios";

class ZoneService extends BaseCrudService<Zone> {
    constructor() {
        super({
            apiPrefix: "zones",
            entityName: "zone",
        });
    }

    async getTeams(zoneId: number, axiosOptions?: AxiosRequestConfig): Promise<Team[]> {
        try {
            const res = await this.axios.get<Team[]>(`/${zoneId}/teams`, axiosOptions);
            return res.data;
        } catch (e) {
            this.tosti.error({
                message: `Could not retrieve teams for zone: ${e.response?.data?.message || e.message}`,
            });
            throw e;
        }
    }

    async addTeam(zoneId: number, teamId: number, axiosOptions?: AxiosRequestConfig): Promise<void> {
        try {
            const res = await this.axios.post(`/${zoneId}/teams/${teamId}`, axiosOptions);
            this.tosti.success({ message: `Team successfully added to zone` });
            return res.data;
        } catch (e) {
            this.tosti.error({
                message: `Could not add team to zone: ${e.response?.data?.message || e.message}`,
            });
            throw e;
        }
    }

    async removeTeam(zoneId: number, teamId: number, axiosOptions?: AxiosRequestConfig): Promise<void> {
        try {
            const res = await this.axios.delete(`/${zoneId}/teams/${teamId}`, axiosOptions);
            this.tosti.success({ message: `Team successfully removed from zone` });
            return res.data;
        } catch (e) {
            this.tosti.error({
                message: `Could not remove team from zone: ${e.response?.data?.message || e.message}`,
            });
            throw e;
        }
    }

    build(fields: Partial<Zone> & Pick<Zone, "floorId">): Zone {
        return {
            name: "New zone",
            type: "workArea",
            opensAt: "09:00:00+00",
            closesAt: "17:00:00+00",
            restriction: "unrestricted",
            liftRestrictionsAt: null,

            ...fields,
        };
    }
}

export const zoneService = new ZoneService();
